import type BaseFolderType from 'owa-service/lib/contract/BaseFolderType';
import getExtendedProperty from './getExtendedProperty';

const SEARCH_FOLDER_ALLOW_AGEOUT_PROPERTY_TAG = '0x361f';

export default function getSearchFolderAllowAgeoutProperty(folderItem: BaseFolderType): boolean {
    const value = getExtendedProperty(folderItem, SEARCH_FOLDER_ALLOW_AGEOUT_PROPERTY_TAG);
    return value === 'true';
}
